import { Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { STUDIOS_COLORS, CHINES_STUDIO_ID, SHUFFLERS_STUDIO_ID } from "constats";
import { getReplacedData } from "store/slice/shiftsSlice";

const checkIsPastDate = (date) => {
    const shiftDate = new Date(date);
    const now = new Date().setHours(0, 0, 0, 0);

    return (now - shiftDate >= 0);
}

const getDateRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const formatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Yerevan', year: 'numeric', month: '2-digit', day: '2-digit' });

    const dates = [];
    while (startDate <= endDate) {
        dates.push(formatter.format(startDate));
        startDate.setDate(startDate.getDate() + 1);
    }
    return dates;
};

const ShiftGenerationTable = (props) => {
    const usersStore = useSelector(store => store.user)
    const shiftStore = useSelector(store => store.shift);
  
    const dealerCellStyle = { width: "250px", fontWeight: "bold", fontSize: 16, paddingLeft: 10 };
    const shiftCellStyle = {
        textAlign: "center", fontSize: 19, fontWeight: 400, cursor: "pointer", padding: 3
    };
    let {openAddingModal = () => {}, shifts = [], creationData = {}, missingDealers} = props;
    const dispatch = useDispatch();
    const account = usersStore.user;

    const chinesCounts = {};
    const shufflersCounts = {};
    const otersConts = {};
    
    const {
        dealers = [],
        // missingDealers = {},
        studios: studioList = []
    } = shiftStore?.shift || {};
    const dateRange = getDateRange(creationData?.startDate, creationData?.endDate);

    const studios = studioList.map((studio, idx) => ({ ...studio, color: STUDIOS_COLORS[idx + 1] }));
    
    const currettDayHaveMissed = (day) => {
        return Object.values(missingDealers).reduce((acc, studio) => {
            const dayData = studio[day];
            if (dayData) {
                acc += Object.values(dayData).reduce((a, b) => a + b, 0);
            }
            return acc;
        }, 0);
    };

    const chinesDealers  = [];
    const shufflers  = [];
    const otherDealers  = [];

    dealers.forEach(dealer => {
        if (dealer.studios.length === 1 && dealer.studios[0]?.id === CHINES_STUDIO_ID) {
            chinesDealers.push(dealer);
        }
        else if (dealer.studios.length === 1 && dealer.studios[0]?.id === SHUFFLERS_STUDIO_ID) {
            shufflers.push(dealer);
        }
        else {
            otherDealers.push(dealer);
        }
        dateRange.forEach(date => {
            const shift = shifts?.[date]?.find(s => s?.dealer?.id === dealer?.id);
            if (!shift?.shift) return;
    
            if (shift?.studio?.id === CHINES_STUDIO_ID) {
                if (!chinesCounts[date]) chinesCounts[date] = {1: 0, 2: 0};
                chinesCounts[date][shift.shift] += 1;
            }
            else if (shift?.studio?.id === SHUFFLERS_STUDIO_ID) {
                if (!shufflersCounts[date]) shufflersCounts[date] = {1: 0, 2: 0};
                shufflersCounts[date][shift.shift] += 1;
            }
            else {
                if (!otersConts[date]) otersConts[date] = {1: 0, 2: 0};
                otersConts[date][shift.shift] += 1;
            }
        });
    });
    

    const renderDealerRow = (dealer, key, idx) => {
        const shiftData = dealer.shift + ' | ' + dealer.workdays + ' - ' + dealer.restDays;
        const isCurrentDealer = dealer?.id == account?.id;

        dealerCellStyle['background'] = 'rgba(240, 242, 245, 1)';
        dealerCellStyle['color'] = '';
        if (isCurrentDealer == true) {
            dealerCellStyle['background'] = 'green';
            dealerCellStyle['color'] = '#fff';
        }
        
        return ((
            <tr key={key} style={{lineHeight: 1}}>
                <td style={{width: "60px", textAlign: "center", fontSize: 16, background: "rgba(240, 242, 245, 1)"}}>
                    {idx}
                </td>
                <td style={{...dealerCellStyle}} title={shiftData}>
                    {dealer.name}
                </td>
                <td style={{background: "rgba(240, 242, 245, 1)"}}>
                    <ul style={{ margin: 0, listStyle: "none", fontSize: "15px", marginLeft: 10 }}>
                        {dealer.studios.map(s => s.name).join(',')}
                    </ul>
                </td>
                {dateRange.map((date, idx) => {
                    const isPastDate = checkIsPastDate(date);
                    
                    const shift = shifts?.[date]?.find(s => s?.dealer?.id === dealer?.id);
                    const studioData = studios.find(s => s.id === shift?.studio?.id);
                

                    const repleacedShift = shiftStore.repleacedShift;
                    const currentDealerId = shift?.dealer?.id;
                    const requestedUseName = repleacedShift?.job?.requestedUser?.name;

                    let title =  shift?.studio?.name;
                    if (requestedUseName) {
                        if (repleacedShift?.userId === currentDealerId) {
                            title = 'Requested by: '+requestedUseName
                        }
                        else if (repleacedShift.job?.requestedUser?.id === currentDealerId) {
                            title = 'Requested to: '+requestedUseName
                        }
                        else if (repleacedShift.job?.targetUser?.id === currentDealerId) {
                            title = 'Requested to: '+requestedUseName
                        }
                    }
     
                    return (
                        <td
                            key={idx}
                            onClick={() => {
                                if (account.role == 'admin') {
                                    openAddingModal(shift, date, dealer.id)
                                }
                                else if (!isPastDate && account.id == dealer.id) {
                                    openAddingModal(shift, date, dealer.id)
                                }
                            }}
                            onMouseEnter={() => {
                                if (shift?.isManual) {
                                    dispatch(getReplacedData(shift))
                                }
                            }}
                            style={{
                                ...shiftCellStyle,
                                color: studioData?.color,
                                background: shift?.did_not_come ? "red" : shift?.isManual ? "green" : "white"
                            }}
                            title={title}
                        >
                            {shift?.shift ? shift?.isFull == 1 ? shift?.shift: `${shift?.shift}/${shift?.part}`: ""}
                        </td>
                    );
                })}
            </tr>
        ))
    };

    return (
        
        <div style={{ overflow: "auto", maxHeight: "900px", display: "inline-block", border: "1px solid #ccc", position: "relative", zIndex: 9999 }}>
                <table border="1" cellPadding="5" cellSpacing="0" style={{ borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ position: 'sticky', top: 0, background: '#f5f5f5', zIndex: 2, fontSize: 16 }}>Id</th>
                            <th style={{ position: 'sticky', top: 0, background: '#f5f5f5', zIndex: 2 , fontSize: 16}}>Dealer</th>
                            <th style={{ position: 'sticky', top: 0, background: '#f5f5f5', zIndex: 2, width: 150, fontSize: 16 }}>Studios</th>
                            {dateRange.map(date => {
                                const isPastDate = checkIsPastDate(date);

                                const missedCount = currettDayHaveMissed(date);
                                return (
                                    <th
                                        key={date}
                                        style={{
                                            writingMode: "vertical-rl",
                                            whiteSpace: "nowrap",
                                            position: 'sticky',
                                            top: 0,
                                            background: !isPastDate ? missedCount ? "red" : "green": "#ccc",
                                            color: "white",
                                            zIndex: 2,
                                            paddingTop: 10,
                                            paddingBottom: 10,
                                            minWidth: 40,
                                            fontSize: 16
                                        }}
                                        title={`Missed count ${missedCount}`}
                                    >
                                        {date}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                      
                        {/* {chinesDealers.map((dealer, idx) => renderDealerRow(dealer, `ch-${idx}`, ++idx))}
         
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                        >
                                            {chinesCounts[date]? chinesCounts[date][1]: ""}
                                        </td>
                                    );
                            })}
                        </tr>
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {chinesCounts[date] ? chinesCounts[date][2]: ""}
                                        </td>
                                    );
                            })}
                        </tr> */}
                        <tr>
                            <td colSpan={dateRange.length + 2} style={{ textAlign: "center", background: "#eee", fontWeight: "bold" }}>
                                New Studio and Armenian Studios Dealers
                            </td>
                        </tr>

                        {
                            otherDealers.map((dealer, idx) => {
                                return renderDealerRow(dealer, `ot-${idx}`, ++idx);
                            })
                        }
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {otersConts[date] ? otersConts[date][1]: ""}
                                        </td>
                                    );
                            })}
                        </tr>
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {otersConts[date] ? otersConts[date][2]: ""}
                                        </td>
                                    );
                            })}
                        </tr>
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {(chinesCounts[date] ? chinesCounts[date][1]: 0)+(otersConts[date] ? otersConts[date][1]: 0)}
                                        </td>
                                    );
                            })}
                        </tr>
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {(chinesCounts[date] ? chinesCounts[date][2]: 0)+(otersConts[date] ? otersConts[date][2]: 0)}
                                        </td>
                                    );
                            })}
                        </tr>
                        
                        <tr>
                            <td colSpan={dateRange.length + 2} style={{ textAlign: "center", background: "#eee", fontWeight: "bold" }}>
                                Shufflers
                            </td>
                        </tr>
                        {
                            shufflers.map((dealer, idx) => {
                                return renderDealerRow(dealer, `ot-${idx}`, ++idx);
                            })
                        }
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                        >
                                            {shufflersCounts[date]? shufflersCounts[date][1]: "0"}
                                        </td>
                                    );
                            })}
                        </tr>
                        <tr style={{lineHeight: 1}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            {dateRange.map((date, idx) => {
                                    return (
                                        <td
                                            key={idx}
                                            style={{textAlign: "center"}}
                                            
                                        >
                                            {shufflersCounts[date] ? shufflersCounts[date][2]: ""}
                                        </td>
                                    );
                            })}
                        </tr>

                    </tbody>
                </table>
            </div>
    )
}

export default ShiftGenerationTable;